// Language-switcher header — intentionally disabled. The app is Polish-only
// (see CLAUDE.md), so this renders nothing. The original implementation is
// preserved below for the day a second locale lands; its `Typography`/`i18n`
// bindings were removed because nothing referenced them while it is inert.

export const Header: React.FC = () => {
  return (<>  </>
    // <div style={{
    //   padding: "0 24px",
    //   display: "flex",
    //   justifyContent: "flex-end",
    //   alignItems: "center",
    //   height: "64px"
    // }}>
    //   <Space>
    //     <GlobalOutlined />
    //     <Select
    //       value={i18n.language}
    //       style={{ width: 120 }}
    //       onChange={(lang: string) => i18n.changeLanguage(lang)}
    //       options={[
    //         { value: "pl", label: "Polski" },
    //         { value: "en", label: "English" },
    //       ]}
    //     />
    //   </Space>
    // </div>
  );
};
